<template lang="pug">
  .no-wrap.overflow-x.scrollable-area.p-1
    b-avatar.mr-1(button, v-for="(platform, index) in platforms", :key="index", :variant="variant(platform)", @click="$emit('click', platform.name)", :id="platform.name")
      v-icon.icon-md(:name="platform.description", v-if="platform.description")
      span(v-else) {{shortName(platform)}}
      b-tooltip(:target="platform.name", placement="bottom") {{platform.title}}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const platformController = createNamespacedHelpers('platform')

export default {
  props: {
    selectedPlatform: {
      type: String,
      default: 'all'
    },
    hideAllTab: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...platformController.mapState({
      accountPlatforms: state => state.platforms
    }),
    platforms () {
      if(!this.hideAllTab){
        const allTab = {
          name: 'all',
          title: 'Todas',
          description: 'list'
        }
        return [allTab, ...this.accountPlatforms]
      }
      return this.accountPlatforms
    },
  },
  methods: {
    ...mapActions([]),
    variant ({name}) {
      return this.selectedPlatform === name ? 'dark' : 'light'
    },
    shortName ({title}) {
      let initials = ''
      const words = title.split(" ")
      for (const word of words) {
        initials += word.charAt(0)
      }
      return initials
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
